import React, { useEffect } from 'react';
import { Input, Row, Col } from 'antd';

const Question4 = ({ data, setData, current }) => {

    const onChange = (value, i) => {
        const copy = [...data.answerVariants].map(x => {
            return { ...x, isRight: 0 };
        });
        copy[i].answerText = value;
        setData({ ...data, answerVariants: [...copy] });
    }


    return (
        <div>
            {
                data.answerVariants.map((el, index) => {
                    return <div>
                        <Row style={{ marginTop: 30 }}>
                            <Col span={2}>{index + 1}</Col>
                            <Col span={12}> <Input value={el.answerText} onChange={(e) => onChange(e.target.value, index)} /></Col>
                        </Row>
                    </div>;
                })

            }
        </div>
    );
}

export default Question4;